'use strict';

var React = require('react');

var SvgStatusActiveMajor = function SvgStatusActiveMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.519 2.395a8 8 0 0 1 5.12.053 1 1 0 0 0 .66-1.888 10 10 0 1 0 6.568 7.812 1 1 0 1 0-1.974.326 8 8 0 1 1-10.373-6.303Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.847 4.74a1.125 1.125 0 0 0-1.694-1.48l-6.208 7.094-2.15-2.15a1.125 1.125 0 0 0-1.59 1.591l3 3a1.125 1.125 0 0 0 1.642-.054l7-8Z"
  }));
};

exports.SvgStatusActiveMajor = SvgStatusActiveMajor;
